@if (filtersForm() && controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
    class="filter-body"
  >
    <mat-form-field appearance="outline">
      <mat-label>{{ title() }}</mat-label>
      <mat-select
        [formControlName]="controlName()"
        [value]="filtersForm().get(controlName()).value"
      >
        @if (title() === FilterTitles.COLLAR_ATTACHED) {
          @for (item of filterList.collarAttachedFilterList; track item) {
            <mat-option [value]="item.value">{{ item.name }}</mat-option>
          }
        } @else {
          @for (item of filterList.statusFilterList; track item) {
            <mat-option [value]="item.value">{{ item.name }}</mat-option>
          }
        }
      </mat-select>
    </mat-form-field>
  </div>
}
